export const MERCHANT = 'merchant';
export const FULFILLER = 'fulfiller';
